import { render, staticRenderFns } from "./DdexToolbar.vue?vue&type=template&id=68871ec4&"
import script from "./DdexToolbar.vue?vue&type=script&lang=js&"
export * from "./DdexToolbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports